import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	parentGroupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	parentGroupLabel: {
		id: 'deep-dive-cards-section.deep-dive-card.dropdown-content.parent-group-label',
		defaultMessage: ', {parent} group',
		description: 'An ARIA label used for boards menu items with parent title.',
	},
});
export default messages;
